export async function subscribeToPush(
  registration: ServiceWorkerRegistration
) {
  const existing = await registration.pushManager.getSubscription();

  if (existing) {
    //await sendSubscription(existing);
    return existing;
  }

  //const permission = 
  await Notification.requestPermission();

  //if (permission === "granted") {
  //  location.reload();
  //}

  // Do not surprise the user with a popup
  if (Notification.permission !== "granted") {
    return null;
  }

  const pushData = document.getElementById("pushData");
  if (!pushData) {
    return null;
  }
  const subscription = await registration.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(pushData.dataset.vapidPublicKey!)
  });

  await sendSubscription(subscription);

  return subscription;
}

async function sendSubscription(
  subscription: PushSubscription
) {
  await fetch("/push_subscriptions", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-CSRF-Token": csrfToken()
    },
    body: JSON.stringify(subscription)
  });
}


function csrfToken() {
  return document.querySelector<HTMLMetaElement>(
    'meta[name="csrf-token"]'
  )!.content;
}

function urlBase64ToUint8Array(base64: string) {
  return Uint8Array.from(
    atob(base64.replace(/-/g, "+").replace(/_/g, "/")),
    c => c.charCodeAt(0)
  );
}